module.exports = __webpack_public_path__ + "static/media/LogicWedge6_3_drag_1.e03636dc.png";